// import React from "react";
// import { Provider } from "react-redux";
// import otherPurchaseStore from "../../../store/otherPurchaseStore";
// import OtherPurchaseLiveTable from "./OtherPurchaseLiveTable";

// const OtherPurchaseUtility = ({includeYearCode=true}) => {
//     const columns = [
//         { label: "Doc No", key: "Doc_No" },
//         { label: "Doc Date", key: "Doc_Date" },
//         { label: "Supplier Name", key: "SupplierName" },
//         { label: "Bill Amount", key: "Bill_Amount" ,format: true },
//         { label: "Narration", key: "Narration" },
//         { label: "opid", key: "opid" }
//     ];

//     return (
//         <Provider store={otherPurchaseStore}>
//             <OtherPurchaseLiveTable
//                 title="Other Purchase"
//                 columns={columns}
//                 rowKey="Doc_No"
//                 addUrl="/other-purchase"
//                 detailUrl="/other-purchase"
//                 permissionUrl="/other-purchaseutility"
//                 includeYearCode={includeYearCode}
//             />
//         </Provider>
//     );
// };

// export default OtherPurchaseUtility;











import React from "react";
import { Provider } from "react-redux";
import otherPurchaseStore from "../../../store/otherPurchaseStore";
import OtherPurchaseLiveTable from "./OtherPurchaseLiveTable";

const API_URL = process.env.REACT_APP_API;

const BillCell = ({ path }) => {
    if (!path) {
        return <span style={{ fontSize: '0.7rem', color: '#999' }}>Not uploded</span>;
    }
    return (
        <span
            title="View bill"
            onClick={(e) => {
                e.stopPropagation(); // don't trigger the row click / double-click navigation
                window.open(`${API_URL}/other-purchase-bill-image/${path}`, '_blank', 'noopener,noreferrer');
            }}
            onDoubleClick={(e) => e.stopPropagation()}
            style={{ cursor: 'pointer', display: 'inline-flex' }}
        >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1a237e" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <circle cx="8.5" cy="8.5" r="1.5" fill="#1a237e" stroke="none" />
                <path d="M21 15l-5-5L5 21" />
            </svg>
        </span>
    );
};

const OtherPurchaseUtility = ({includeYearCode=true}) => {
    const columns = [
        { label: "Doc No", key: "Doc_No" },
        { label: "Doc Date", key: "Doc_Date" },
        {
            label: "Bill",
            key: "billimage_path",
            align: "center",
            render: (row) => <BillCell path={row.billimage_path}  />,
        },
        { label: "Supplier Name", key: "SupplierName" },
        { label: "Bill Amount", key: "Bill_Amount" ,format: true },
        { label: "Narration", key: "Narration" },
        { label: "opid", key: "opid" }
    ];

    return (
        <Provider store={otherPurchaseStore}>
            <OtherPurchaseLiveTable
                title="Other Purchase Bill"
                columns={columns}
                rowKey="Doc_No"
                addUrl="/other-purchase"
                detailUrl="/other-purchase"
                permissionUrl="/other-purchaseutility"
                includeYearCode={includeYearCode}
            />
        </Provider>
    );
};

export default OtherPurchaseUtility;